export default __webpack_public_path__ + "static/media/GR5 5C.9b6a79a1.jpg";